let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("121OC")).then(() => parcelRequire('fguF3'));